import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { TimeSheetDelegate } from "./timesheet.delegate";
import { TimeSheetService } from "./timesheet.service";

export class TimeSheetServiceFactory
{
    static create(
        config: IAppConfig,
        spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): TimeSheetService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new TimeSheetDelegate(httpProvider);

        return new TimeSheetService(delegate, authenticationService);
    }
}
